import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import RolesService from "../../../../../services/AdminManagment/RolesService";
import DeleteModal from "../../../../common/DeleteModal";
import { Translate } from "../../../../Enums/Tranlate";
import { useNavigate } from "react-router-dom";

const CardItem = ({ item, setItem, index, setAddModal, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const [type, setType] = useState("");
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const rolesService = new RolesService();
	const navigate = useNavigate();

	return (
		<tr key={index} className="text-center">
			<td>{item?.name}</td>
			<td>{item?.adminsCount}</td>
			<td>
				{/* {(isExist("edit_employees") && isExist("delete_employees")) &&  */}
				<Dropdown>
					<Dropdown.Toggle className="light sharp i-false">
						<i className="la la-ellipsis-v" style={{ fontSize: "27px" }}></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						{/* {isExist("edit_employees") &&  */}
						<Dropdown.Item
							onClick={() => {
								setItem(item);
								navigate(`/roles/${item?.id}`, { state: item });
							}}>
							{" "}
							{Translate[lang]?.edit}
						</Dropdown.Item>
						{/* } */}
						{/* {isExist("delete_employees") &&  */}
						<Dropdown.Item
							onClick={() => {
								setDeleteModal(true);
								setType("delete");
							}}>
							{Translate[lang]?.delete}
						</Dropdown.Item>
						{/* } */}
					</Dropdown.Menu>
				</Dropdown>
				{/* } */}
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={rolesService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
					type={type}
				/>
			)}
		</tr>
	);
};
export default CardItem;
